import React, { useState } from 'react';
import { Link } from 'gatsby';
import { Icon } from 'react-icons-kit';
import { arrowRight } from 'react-icons-kit/feather/arrowRight';
import { closeCircled } from 'react-icons-kit/ionicons/closeCircled';

import Container from 'common/components/UI/Container';
import Button from 'common/components/Button';
import Image from 'common/components/Image';
import gift from 'common/assets/image/hostingModern/gift.png';
import TopBarWrapper, {
  TopbarInner,
  TopBarMobile,
  Wrapper,
} from './topbar.style';

const TopBar = () => {
  const [closeTopBar, setCloseTopBar] = useState(false);

  const handleClose = () => {
    setCloseTopBar(true);
  };

  return (
    <TopBarWrapper isHide={closeTopBar && closeTopBar}>
      <Container>
        <TopbarInner>
          <p className="caption">
            <Image src={gift} alt="gift icon" />
            Cyber monday sale begin, just grave the hot pricing
            <strong className="tlds">Discount code, aPay2021</strong>
          </p>

          <Link to={`/#pricing`} className="dealsLink">
            <span>Get Started</span>
            <Icon className="close" icon={arrowRight} size={14} />
          </Link>
          <Button
            onClick={handleClose}
            className="closeTopBar"
            icon={<Icon className="close" icon={closeCircled} size={20} />}
          />
        </TopbarInner>
        <TopBarMobile>
          <Wrapper>
            <p className="caption">
              <Image src={gift} alt="gift icon" />
              <span>Cyber monday sale begin, just grave the hot pricing</span>
            </p>
            <p>
              <strong className="tlds">Discount code, aPay2021</strong>

              <Link to={`/#pricing`} className="dealsLink">
                <span>Get Started</span>
                <Icon className="close" icon={arrowRight} size={14} />
              </Link>
            </p>
          </Wrapper>
          <Button
            onClick={handleClose}
            className="closeTopBar"
            icon={<Icon className="close" icon={closeCircled} size={20} />}
          />
        </TopBarMobile>
      </Container>
    </TopBarWrapper>
  );
};

export default TopBar;
